export default __webpack_public_path__ + "static/media/mentor_mock_1.e9e6a492.png";